import React from "react";

const BridgingLonGuide = () => {
  return <div>BridgingLonGuide</div>;
};

export default BridgingLonGuide;
